import { Navigate, Outlet } from 'react-router'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import { useCanViewDataSources } from './useCanViewDataSources'

/** Sends users who can't see Data Sources to the 404 page */
export const DataSourcesGuardLayout = () => {
  const { isLoading } = useGlobalContext()
  const canViewDataSources = useCanViewDataSources()

  // Whether the user is internal isn't known until their roles load
  if (isLoading) {
    return null
  }
  if (!canViewDataSources) {
    return <Navigate replace to="/404" />
  }
  return <Outlet />
}
